<template>
  <div class="m-auto" :class="{ 'm-1230': !isModal }">
    <div class="row align-items-center" v-if="!isModal">
      <div class="col-lg-6 d-none d-lg-block">
        <img src="@/assets/images/login.jpg" class="rounded-3" alt="forgot password" />
      </div>
      <div class="col-lg-6">
        <div class="mw-480 ms-lg-auto">
          <h3 class="fs-28 mb-2" v-if="!isModal">Password Dimenticata?</h3>
          <p class="fw-medium fs-16 mb-4" v-if="!isModal">
            Inserisci il tuo indirizzo email e ti invieremo un link per reimpostare la password.
          </p>

          <!-- Modal version header -->
          <div v-if="isModal" class="text-center mb-4">
            <h4 class="mb-2">Password Dimenticata?</h4>
            <p class="text-muted">
              Inserisci la tua email per ricevere il link di reset
            </p>
          </div>

          <form @submit.prevent="handleForgotPassword" class="auth-form">
            <!-- Success Message -->
            <div v-if="successMessage" class="alert alert-success d-flex align-items-center" role="alert">
              <i class="material-symbols-outlined me-2">check_circle</i>
              <span>{{ successMessage }}</span>
            </div>

            <!-- API Error Message -->
            <div v-if="apiError" class="alert alert-danger d-flex align-items-center" role="alert">
              <i class="material-symbols-outlined me-2">error</i>
              <span>{{ apiError }}</span>
            </div>

            <div v-if="!emailSent">
              <div class="form-floating mb-4">
                <input
                  type="email"
                  class="form-control h-55"
                  :class="{ 'is-invalid': emailError }"
                  id="forgotEmail"
                  placeholder="esempio@email.com"
                  v-model="email"
                  @blur="validateEmail"
                  @input="validateEmail"
                  required
                />
                <label for="forgotEmail">Indirizzo Email</label>
                <div v-if="emailError" class="invalid-feedback">
                  {{ emailError }}
                </div>
              </div>

              <div class="form-group mb-4">
                <button
                  type="submit"
                  class="btn btn-primary fw-medium py-2 px-3 w-100"
                  :disabled="!isFormValid || isLoading"
                >
                  <div v-if="isLoading" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <div v-else class="d-flex align-items-center justify-content-center py-1">
                    <i class="material-symbols-outlined text-white fs-20 me-2">email</i>
                    <span>Invia link di reset</span>
                  </div>
                </button>
              </div>
            </div>

            <div v-else class="text-center">
              <p class="mb-4">
                Controlla la tua casella di posta elettronica e clicca sul link che ti abbiamo inviato per reimpostare la password.
              </p>
              <button
                type="button"
                class="btn btn-outline-primary fw-medium py-2 px-3"
                @click="resetForm"
              >
                Invia di nuovo
              </button>
            </div>

            <div class="form-group">
              <p class="text-center">
                Ti sei ricordato la password?
                <RouterLink
                  to="/authentication/login"
                  class="fw-medium text-primary text-decoration-none"
                >
                  Torna al Login
                </RouterLink>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal version - no image, different layout -->
    <div v-if="isModal">
      <div class="text-center mb-4">
        <h4 class="mb-2">Password Dimenticata?</h4>
        <p class="text-muted">
          Inserisci la tua email per ricevere il link di reset
        </p>
      </div>

      <form @submit.prevent="handleForgotPassword" class="auth-form">
        <!-- Success Message -->
        <div v-if="successMessage" class="alert alert-success d-flex align-items-center" role="alert">
          <i class="material-symbols-outlined me-2">check_circle</i>
          <span>{{ successMessage }}</span>
        </div>

        <!-- API Error Message -->
        <div v-if="apiError" class="alert alert-danger d-flex align-items-center" role="alert">
          <i class="material-symbols-outlined me-2">error</i>
          <span>{{ apiError }}</span>
        </div>

        <div v-if="!emailSent">
          <div class="form-floating mb-4">
            <input
              type="email"
              class="form-control h-55"
              :class="{ 'is-invalid': emailError }"
              id="modalForgotEmail"
              placeholder="esempio@email.com"
              v-model="email"
              @blur="validateEmail"
              @input="validateEmail"
              required
            />
            <label for="modalForgotEmail">Indirizzo Email</label>
            <div v-if="emailError" class="invalid-feedback">
              {{ emailError }}
            </div>
          </div>

          <div class="form-group mb-4">
            <button
              type="submit"
              class="btn btn-primary fw-medium py-2 px-3 w-100"
              :disabled="!isFormValid || isLoading"
            >
              <div v-if="isLoading" class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div v-else class="d-flex align-items-center justify-content-center py-1">
                <i class="material-symbols-outlined text-white fs-20 me-2">email</i>
                <span>Invia link di reset</span>
              </div>
            </button>
          </div>
        </div>

        <div v-else class="text-center">
          <p class="mb-4">
            Email inviata! Controlla la tua casella di posta.
          </p>
          <p v-if="isModal && countdown > 0" class="text-muted small mb-3">
            Tornerai automaticamente al login tra {{ countdown }} secondi
          </p>
          <button
            type="button"
            class="btn btn-outline-primary fw-medium py-2 px-3 me-2"
            @click="resetForm"
          >
            Invia di nuovo
          </button>
          <button
            type="button"
            class="btn btn-link fw-medium py-2 px-3"
            @click="$emit('switch-to-login')"
          >
            Torna al Login
          </button>
        </div>

        <div class="form-group" v-if="!emailSent">
          <p class="text-center">
            Ti sei ricordato la password?
            <a
              href="#"
              @click.prevent="$emit('switch-to-login')"
              class="fw-medium text-primary text-decoration-none"
            >
              Torna al Login
            </a>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import authService from "@/services/authService";
import { formatErrorMessage } from "@/utils/errorUtils";

export default defineComponent({
  name: "ForgotPassword",
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  emits: ['forgot-success', 'switch-to-login'],
  setup(props, { emit }) {
    const email = ref('');
    const emailError = ref('');
    const apiError = ref('');
    const successMessage = ref('');
    const isLoading = ref(false);
    const emailSent = ref(false);
    const countdown = ref(0);

    const validateEmail = () => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email.value) {
        emailError.value = 'L\'email è obbligatoria';
        return false;
      }
      if (!emailRegex.test(email.value)) {
        emailError.value = 'Inserisci un indirizzo email valido';
        return false;
      }
      emailError.value = '';
      return true;
    };

    const isFormValid = computed(() => {
      return email.value && !emailError.value;
    });

    const handleForgotPassword = async () => {
      if (!validateEmail()) {
        return;
      }

      isLoading.value = true;
      apiError.value = '';
      successMessage.value = '';

      try {
        const response = await authService.forgotPassword({
          email: email.value
        });

        console.log('ForgotPassword Response:', response);
        console.log('Response data:', response.data);
        console.log('Response status:', response.status);

        // Check for success - Laravel might return different response structures
        if (response.status === 200 || response.data.status === 200) {
          successMessage.value = response.data.message || 'Email di reset inviata con successo!';
          emailSent.value = true;

          // Start countdown only if used as modal
          if (props.isModal) {
            countdown.value = 10;
            const countdownInterval = setInterval(() => {
              countdown.value--;
              if (countdown.value <= 0) {
                clearInterval(countdownInterval);
              }
            }, 1000);
          }

          emit('forgot-success');
        }
      } catch (error: any) {
        console.error("Forgot password failed:", error);
        apiError.value = formatErrorMessage(error);
      } finally {
        isLoading.value = false;
      }
    };

    const resetForm = () => {
      emailSent.value = false;
      successMessage.value = '';
      apiError.value = '';
    };

    return {
      email,
      emailError,
      apiError,
      successMessage,
      isLoading,
      emailSent,
      countdown,
      isFormValid,
      validateEmail,
      handleForgotPassword,
      resetForm
    };
  },
});
</script>